<template>
    <div class="document-create-route">
        <router-view />
    </div>
</template>

<script>

export default {
    name: "document_create_root",
}
</script>

<style scoped>
.document-create-route {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    overflow-x: hidden;
    box-sizing: border-box;
}
</style>
